module.exports = __webpack_public_path__ + "media/packs/images/flags/SM-997b10a879f4644362d1026c6826736d.png";